var map = {
	"./address_image.svg": 256,
	"./amrita_logo.png": 9876,
	"./coursera_logo.png": 4664,
	"./duke-logo.jpg": 7793,
	"./fractal-logo.jpg": 2556,
	"./gcp_logo.png": 4585,
	"./ggsipu_logo.png": 1007,
	"./google_logo.png": 8720,
	"./ibm-logo.png": 2436,
	"./ibm_logo.jpg": 5419,
	"./infosys-logo.png": 9006,
	"./mail.gif": 526,
	"./mail.png": 3655,
	"./maryland_logo.svg": 6393,
	"./meta_logo.png": 484,
	"./ottonomy-logo.webp": 7749,
	"./portfolioProfileImage.png": 4836,
	"./waving-hand.png": 8697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;